import React,{useState,useEffect} from 'react'
import { Route, BrowserRouter as Router, Routes, Link, NavLink } from 'react-router-dom';
import { IntrigrationLeftSec } from '../components/intrigrationLeftSec';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import ScrollToTop from "react-scroll-to-top";
import config from '../Config';

import { IntegrantionModuleService } from '../services/IntegrantionModuleService';

interface IState {
    loading: boolean;
    module: any;
    errorMsg: string;
  }

export const IntegrationsWooCommerceSec = () => {


    const [state, setState] = useState<IState>({
        loading: false,
        module: [] as any,
        errorMsg: "",
    });

    //network request
    useEffect(() => {
        setState({ ...state, loading: true });
        IntegrantionModuleService.getModuleDetails('WooCommerce')
        .then((res) =>{
        setState({
            ...state,
            loading: false,
            module: res.data as any,
        })

        }
        
        )
        .catch((err) =>{
        setState({
            ...state,
            loading: false,
            errorMsg: err.message,
        })

        }
        );
    //eslint-disable-next-line
    }, []);


    const { loading, module, errorMsg } = state;
    const modDetails = module.response?.module_details;
    const latestVersion = module.response?.module_details.length > 0 ? module.response.module_details[0] : [];
    const contentDetArr = module.response?.module_details.length > 0 ? module.response.module_details[0].jsoncontent : [];

    return (
        <>
            <section className="credit-api-main">
                <img src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bg.svg`} alt="" className='apibg' />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <IntrigrationLeftSec />
                        </div>
                        <div className="col-lg-9">
                            <div className="creadit-api-upper-wrapper">
                                <Link to="/integrations" className='apidetail-btn'><FontAwesomeIcon icon={faArrowRight} /> Return to Integrations page</Link>
                                <h1>WooCommerce</h1>

                                <ul className="card-url">
                                    {Object.entries(contentDetArr).map(([keyName, keyValue]: [any, any]) => (
                                        <>
                                        <li>
                                            <div className="card-url-list">
                                                <p>{keyName}:</p>
                                                <span>{keyValue}</span>
                                            </div>
                                        </li>
                                        </>
                                    ))}
                                </ul>
                                <p className='mt-30'>This plugin allows you to use the TCB Pay payment portal for your WooCommerce site, as an additional payment option.</p>
                            </div>

                            <div className="creadit-api-lower-wrapper">
                                <div className="api-menu-item-wrapper">
                                    <h3>Installation</h3>
                                    <hr />
                                    <Link to={`${config.pluginModuleUrl}/${latestVersion.download_url}/${latestVersion.file_name}`} target='_blank' className="integration-btn1 mb-integration mb-20">Download the WooCommerce extension package<FontAwesomeIcon icon={faArrowRight} /></Link>
                                    {modDetails?.length > 1 &&
                                        <>
                                            <p>Download older versions of the package:</p>
                                            <div className="listintri">
                                                <ul>
                                                {modDetails?.map((keyName: any) => (
                                                    <>
                                                        <li>Download <Link to={`${config.pluginModuleUrl}/${keyName.download_url}/${keyName.file_name}`} target='_blank'>{keyName.version_name}</Link> 
                                                        {keyName.dependency ? `for ${keyName.dependency}` : ""}</li>
                                                    </>
                                                    ))
                                                }
                                                </ul>
                                            </div>
                                        
                                        </>
                                    }

                                </div>
                            </div>

                            <div className="example-box-wrapper mt-30 mb-30">
                                <div className="d-flex align-items-start">
                                    <p>There are two ways to install the plugin.</p>
                                </div>
                            </div>

                            <div className="example-box-wrapper mb-30">
                                <div className="d-flex align-items-start">
                                    <b>1 </b>
                                    <p>Place the unzipped plugin into the wp-content/plugins folder inside your WordPress site.</p>
                                </div>
                            </div>

                            <div className="example-box-wrapper mb-30">
                                <div className="d-flex align-items-start">
                                    <b>2 </b>
                                    <p>From WordPress admin go to Plugins – Add New. Click on Upload Plugin, and browse the zip version of the TCB Pay plugin folder.</p>
                                </div>
                            </div>

                            <img src={`${config.siteBaseUrl}/assets/imgs/ss-1.png`} alt='' />

                            <div className="api-menu-item-wrapper mt-60">
                                <h3>Manage Plugin</h3>
                                <hr />
                                <p>After successfully installing the plugin, activate the TCBPay plugin by navigating to Plugins → Installed Plugins.<br/>
                                Once the TCBPay plugin is activated, you can manage the plugin settings from Woo-commerce → Settings → Payments → TCBPay.</p>
                                <p>In the manage screen, you can set the following values:</p>
                                <div className='listintri'>
                                    <ul className='mb-40'>
                                        <li><strong>Title:</strong> Name what you wish to appear on your cart page as a payment option.</li> 
                                        <li><strong>Description:</strong> If you wish to specify any notes for the plugins for your customers.</li> 
                                        <li><strong>Username:</strong> This is the username provided by TCBPay when you signed up for an account.</li> 
                                        <li><strong>API Key:</strong> This is the API Key provided by TCBPay when you signed up for an account.</li> 
                                    </ul>
                                    <p>Keep the Enable test mode checked, if you want to run the Plugin in a test environment.</p>
                                </div>
                                
                                <img src={`${config.siteBaseUrl}/assets/imgs/ss-2.png`} alt='' />
                            </div>

                        </div>
                    </div>
                </div>
                <img src={`${config.siteBaseUrl}/assets/imgs/blue-lowerdots.svg`} alt="" className="orng-dots" />

                <ScrollToTop smooth />
            </section>
        </>
    )
}
